
import {default as app} from '@legacy/App';

app.controller('LogoutController', function ($scope, $rootScope, $state, $http, settings, masterFactory) {
    // Initialization - this runs on load
    var init = function () {

        $rootScope.user.isAuthenticated = false;
        $rootScope.user.username = "";
        $rootScope.user.company = "";
        $http.defaults.headers.common.Authorization = null;        
        
        sessionStorage.clear();
        masterFactory.RefreshDbIcon();
        $state.go('login');
    };

    init();


});